import React from "react";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Grid, Typography, Card } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import MenuItem from "@mui/material/MenuItem";
import { Formik } from "formik";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import moment from "moment";
import Select from "@mui/material/Select";

export default function EditWorkOrder() {
  const history = useHistory();
  let { id } = useParams();
  const data_params = { id: id };
  const EmpId = localStorage.getItem("EmpId");
  const [spFactory_fetch_Data, setspFactory_fetch_data] = useState([]);
  const [location_fetch_Data, setLocation_fetch_data] = useState([]);
  const [booking_data, setBooking_data] = useState([]);
  const [fetch_data_booking, setFetch_booking_data] = useState([]);
  //TextField Disable
  const [DetDemDisable, setDetDemDisable] = useState(false);
  const [ComDisable, setComDisable] = useState(false);
  const [spFactory, setspFactory] = useState("");
  const [ModId, setModId] = localStorage.getItem("EmpId");
  const [Submitting, setSubmitting] = useState(false);
  //const etdpol closingdate 1st
  const [com_caluateSelect, setCom_caluateSelect] = useState(false);

  //fetch Data
  const getFactoryList = async () => {
    try {
      const data = await api.get("api/factory/list");

      setspFactory_fetch_data(data.data);
      //   console.log(data.data);
    } catch (e) {
      console.log(e);
    }
  };
  //fetch Data location
  const getLocationList = async () => {
    try {
      const data = await api.get("api/master/location");
      setLocation_fetch_data(data.data.data);
    } catch (e) {
      console.log(e);
    }
  };
  //fetch Booking
  const getBookingNo = async () => {
    try {
      const data = await api.get("api/master/workorder/booking");
      //   console.log(data.data.data);
      setBooking_data(data.data.data);
    } catch (e) {
      console.log(e);
    }
  };
  //fetch booking detail
  const getBookingDetail = async (id) => {
    const params = {
      booking: id,
    };
    try {
      const data = await api
        .post("api/master/workorder/booking/detail", params)
        .then((response) => {
          if (response.data.length !== 0) {
            response.data.data.map((res) => {
              setFetch_booking_data(res);
            });
          } else {
            const MySwal = withReactContent(Swal);

            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "ผิดพลาด!",
                "ไม่พบรหัสอ้างอิงดังกล่าว !",
                "error"
              );
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const getData = async () => {
    try {
      const data = await api
        .post("api/liners/detail", data_params)
        .then((response) => {
          if (response.data.length !== 0) {
            console.log(response.data);
            [].concat(response.data).map((res) => {});
          } else {
            const MySwal = withReactContent(Swal);

            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "ผิดพลาด!",
                "ไม่พบรหัสอ้างอิงดังกล่าว !",
                "error"
              ).then((result) => {
                if (result.isConfirmed) {
                  history.push("/Setting/Liners");
                }
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const addData = async () => {
    const data = {
      createId: EmpId,
    };

    api
      .post("api/liners/create", data)
      .then((respose) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
          icon: "success",
          didOpen: () => {
            MySwal.clickConfirm();
          },
        }).then(() => {
          return MySwal.fire(
            "สำเร็จ!",
            "เพิ่มสารการเดินเรือ !",
            "success"
          ).then((result) => {
            if (result.isConfirmed) {
              history.push("/Setting/Liners");
            }
          });
        });
      })
      .catch((err) => {
        console.log(err);
      });
    // alert(JSON.stringify(data, null, 2));
    setSubmitting(false);
  };

  const editData = async () => {
    const data = {
      id: id,

      ModId: EmpId,
    };

    api
      .post("api/liners/update", data)
      .then((respose) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
          icon: "success",
          didOpen: () => {
            MySwal.clickConfirm();
          },
        }).then(() => {
          return MySwal.fire(
            "สำเร็จ!",
            "แก้ไขสารการเดินเรือ !",
            "success"
          ).then((result) => {
            if (result.isConfirmed) {
              history.push("/Setting/Liners");
            }
          });
        });
      })
      .catch((err) => {
        console.log(err);
      });
    // alert(JSON.stringify(data, null, 2));
    setSubmitting(false);
  };

  useEffect(() => {
    if (id) {
      getData();
    }
    getBookingNo();
    getFactoryList();
    getLocationList();
  }, []);

  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          ใบสั่งงาน
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Work Order
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Truck / WorkOrder</Typography>
            <Typography>
              <span>&nbsp;</span> / Detail
            </Typography>
          </Grid>
        </Grid>

        <Formik
          enableReinitialize
          initialValues={{
            so_id: "",
            work_no: "",
            assign_date: "",
            customer_id: "",
            Customer: "",
            booking_no: "",
            factory: "",
            tel: "",
            pickup_date: "",
            factory_addr: "",
            etd_pol: "",
            closing_date: "",
            closing_time: "",
            etd_icd: "",
            det: "",
            dem: "",
            com: "",
            from: "",
            to: "",
          }}
          validate={(values) => {
            const errors = {};

            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            // console.log(values);
            setTimeout(() => {
              if (id) {
                editData();
              } else {
                const data = {
                  soId: values.so_id,
                  workorderNo: values.work_no,
                  cusId: values.customer_id,
                  assDate: values.assign_date,
                  bookingNo: values.booking_no,
                  factoryId: spFactory,
                  etdPol: values.etd_pol,
                  closeingDate: values.closing_date,
                  closeingTime: values.closing_time,
                  pickupDate: values.pickup_date,
                  ladenEtd: values.etd_icd,
                  det: values.det,
                  dem: values.dem,
                  com: values.com,
                  freetimeFrom: values.from,
                  freetimeTo: values.to,
                  status: 1,
                  createId: EmpId,
                };
                console.log(data);
                api
                  .post("api/workorder/create", data)
                  .then((respose) => {
                    const MySwal = withReactContent(Swal);

                    MySwal.fire({
                      icon: "success",
                      didOpen: () => {
                        MySwal.clickConfirm();
                      },
                    }).then(() => {
                      return MySwal.fire(
                        "สำเร็จ!",
                        "เพิ่ม Work Order สำเร็จ !",
                        "success"
                      ).then((result) => {
                        if (result.isConfirmed) {
                          history.push("/Truck/WorkOrder");
                        }
                      });
                    });
                    console.log(respose);
                  })
                  .catch((err) => {
                    console.log(err);
                  });
                // alert(JSON.stringify(values, null, 2));
                setSubmitting(false);
              }
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
              <Grid container>
                <Grid item xs={6} sm={3} md={12} sx={{ display: "flex" }}>
                  <TextField
                    name="work_no"
                    label="Work NO."
                    variant="outlined"
                    placeholder="Enter Work NO."
                    style={{
                      width: "50%",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    InputLabelProps={{ shrink: true }}
                    value={values.work_no}
                  />
                  <TextField
                    name="assign_date"
                    label="ASSIGN Date."
                    variant="outlined"
                    type="date"
                    style={{
                      width: "50%",
                      marginTop: "10px",
                      marginBottom: "10px",
                      marginLeft: "10px",
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    InputLabelProps={{ shrink: true }}
                    value={values.assign_date}
                  />
                </Grid>
                <Grid item xs={6} sm={3} md={12} sx={{ display: "flex" }}>
                  <FormControl style={{ width: "50%" }}>
                    <InputLabel id="BOOKING NO-label">BOOKING NO</InputLabel>
                    <Select
                      name="booking_no"
                      value={values.booking_no}
                      label="BOOKING NO"
                      style={{
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                      onChange={(e) => {
                        setFieldValue("booking_no", e.target.value);
                        const params = {
                          booking: e.target.value,
                        };
                        try {
                          const data = api
                            .post("api/master/workorder/booking/detail", params)
                            .then((response) => {
                              if (response.data.length !== 0) {
                                response.data.data.map((res) => {
                                  console.log(res);
                                  setFieldValue("customer_id", res.CustomerId);
                                  setFieldValue("so_id", res.SoId);
                                  setFieldValue("Customer", res.CustomerName);
                                  setFieldValue(
                                    "closing_time",
                                    res.EtdCloseingTime
                                  );
                                  setFieldValue("etd_pol", res.EtdPol);
                                  setFieldValue(
                                    "closing_date",
                                    res.EtdCloseingDate
                                  );

                                  setFieldValue("pickup_date", res.PickupFirst);
                                  setFieldValue("det", res.FreePoLDet);
                                  setFieldValue("dem", res.FreePoLDem);
                                  setFieldValue("com", res.FreePoLCom);
                                });
                              } else {
                                const MySwal = withReactContent(Swal);

                                MySwal.fire({
                                  icon: "success",
                                  didOpen: () => {
                                    MySwal.clickConfirm();
                                  },
                                }).then(() => {
                                  return MySwal.fire(
                                    "ผิดพลาด!",
                                    "ไม่พบรหัสอ้างอิงดังกล่าว !",
                                    "error"
                                  );
                                });
                              }
                            })
                            .catch((err) => {
                              console.log(err);
                            });
                        } catch (e) {
                          console.log(e);
                        }
                      }}
                      onBlur={handleBlur}
                    >
                      <MenuItem value="" disabled>
                        <em>เลือก BookingNo </em>
                      </MenuItem>
                      {booking_data.map((option, index) => {
                        return (
                          <MenuItem key={index} value={option.Booking}>
                            {option.Booking}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <TextField
                    label="Customer"
                    InputLabelProps={{ shrink: true }}
                    placeholder="Customer"
                    name="Customer"
                    inputProps={{ readOnly: true }}
                    style={{
                      width: "50%",
                      marginTop: "10px",
                      marginBottom: "10px",
                      marginLeft: "10px",
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.Customer}
                  />
                </Grid>
                <Grid item xs={6} sm={3} md={12} sx={{ display: "flex" }}>
                  <FormControl sx={{ width: "100%" }}>
                    <InputLabel>Factory</InputLabel>
                    <Select
                      name="spFactory"
                      label="COMMODITY"
                      style={{
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                      value={spFactory}
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) => {
                        // console.log(e.target.value);
                        setspFactory(e.target.value);

                        const find_data = spFactory_fetch_Data.find(
                          (v) => v.FactoryId === e.target.value
                        );

                        setFieldValue("tel", find_data.FactoryMobile);
                        setFieldValue("factory_addr", find_data.FactoryAddress);
                      }}
                    >
                      <MenuItem value="" disabled>
                        <em>เลือก Factory </em>
                      </MenuItem>
                      {spFactory_fetch_Data.map((option, index) => {
                        return (
                          <MenuItem key={index} value={option.FactoryId}>
                            {option.FactoryName}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <TextField
                    name="tel"
                    label="Tel"
                    variant="outlined"
                    placeholder="Enter Tel"
                    style={{
                      width: "25%",
                      marginTop: "10px",
                      marginBottom: "10px",
                      marginLeft: "10px",
                    }}
                    inputProps={{ readOnly: true }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    InputLabelProps={{ shrink: true }}
                    value={values.tel}
                  />
                  <TextField
                    name="factory_addr"
                    label="Factory Address"
                    variant="outlined"
                    style={{
                      width: "50%",
                      marginTop: "10px",
                      marginBottom: "10px",
                      marginLeft: "10px",
                    }}
                    inputProps={{ readOnly: true }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    InputLabelProps={{ shrink: true }}
                    value={values.factory_addr}
                  />
                </Grid>
                <Grid item xs={6} sm={3} md={12} sx={{ display: "flex" }}>
                  <TextField
                    name="etd_pol"
                    label="ETD POL"
                    type="date"
                    value={values.etd_pol}
                    onChange={(e) => {
                      setFieldValue("etd_pol", e.target.value);

                      if (values.dem != "" && values.det != "") {
                        let cal_days =
                          -(parseInt(values.det) + parseInt(values.dem)) + 2;
                        let date_now = +new Date(e.target.value);
                        if (values.det != "" && values.dem != "") {
                          setFieldValue(
                            "pickup_date",
                            moment(
                              new Date(
                                date_now + cal_days * 24 * 60 * 60 * 1000
                              )
                            ).format("DD/MM/YYYY")
                          );
                        }
                      }
                    }}
                    defaultValue="2017-05-24"
                    sx={{ width: "25%" }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TextField
                    name="closing_date"
                    label="CLOSING DATE"
                    type="date"
                    value={values.closing_date}
                    onChange={(e) => {
                      setFieldValue("closing_date", e.target.value);
                      if (
                        values.com != "" &&
                        values.det == "" &&
                        values.dem == "" &&
                        values.choice_com_calculate == "2"
                      ) {
                        let date_now = +new Date(e.target.value);

                        setFieldValue(
                          "pickup_date",
                          moment(
                            new Date(
                              date_now + values.com * 24 * 60 * 60 * 1000
                            )
                          ).format("DD/MM/YYYY")
                        );
                      }
                    }}
                    defaultValue="2017-05-24"
                    style={{ width: "25%", marginRight: 5, marginLeft: 5 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TextField
                    name="closing_time"
                    label="CLOSING TIME"
                    variant="outlined"
                    type="time"
                    placeholder="CLOSING TIME"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    style={{ width: "50%", marginRight: 5 }}
                    InputLabelProps={{ shrink: true }}
                    value={values.closing_time}
                  />
                  {errors.closing_time &&
                    touched.closing_time &&
                    errors.closing_time}
                </Grid>
                <Grid item xs={6} sm={3} md={12} sx={{ display: "flex" }}>
                  <TextField
                    name="pickup_date"
                    label="PICK-UP DATE"
                    variant="outlined"
                    placeholder="Enter PICK-UP DATE"
                    style={{
                      width: "50%",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ readOnly: true }}
                    value={values.pickup_date}
                  />
                  <TextField
                    name="etd_icd"
                    label="LADEN ETD ICD-TS (DATE)"
                    variant="outlined"
                    type="date"
                    placeholder="Enter LADEN ETD ICD-TS (DATE)"
                    style={{
                      width: "50%",
                      marginTop: "10px",
                      marginBottom: "10px",
                      marginLeft: "10px",
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    InputLabelProps={{ shrink: true }}
                    value={values.etd_icd}
                  />
                </Grid>

                <h6
                  style={{ marginTop: "10px" }}
                  fullWidth
                  className="textcolordarkblue"
                >
                  FREE TIME AT POL
                </h6>

                <Grid item xs={6} sm={3} md={12} sx={{ display: "flex" }}>
                  <TextField
                    name="det"
                    label="DET"
                    type="number"
                    variant="outlined"
                    placeholder="DET"
                    onChange={(e) => {
                      setFieldValue("det", e.target.value);

                      // setDetValue(e.target.value);
                      let cal_days =
                        -(parseInt(e.target.value) + parseInt(values.dem)) + 2;
                      let date_now = +new Date(values.etd_pol);
                      if (
                        e.target.value != "" &&
                        values.dem != "" &&
                        values.etd_pol != ""
                      ) {
                        setFieldValue(
                          "pickup_date",
                          moment(
                            new Date(date_now + cal_days * 24 * 60 * 60 * 1000)
                          ).format("DD/MM/YYYY")
                        );
                      }
                      if (e.target.value == "") {
                        setFieldValue("pickup_date", "");
                      }
                      e.target.value.length >= 1 || values.dem != ""
                        ? setComDisable(true)
                        : setComDisable(false);
                    }}
                    onBlur={handleBlur}
                    style={{ width: "50%", marginRight: 5 }}
                    InputLabelProps={{ shrink: true }}
                    disabled={DetDemDisable}
                    value={values.det}
                  />
                  {errors.det && touched.det && errors.det}
                  <TextField
                    name="dem"
                    label="DEM"
                    type="number"
                    variant="outlined"
                    placeholder="DEM"
                    onChange={(e) => {
                      setFieldValue("dem", e.target.value);
                      let cal_days =
                        -(parseInt(values.det) + parseInt(e.target.value)) + 2;
                      let date_now = +new Date(values.etd_pol);
                      if (
                        values.det != "" &&
                        e.target.value != "" &&
                        values.etd_pol != ""
                      ) {
                        setFieldValue(
                          "pickup_date",
                          moment(
                            new Date(date_now + cal_days * 24 * 60 * 60 * 1000)
                          ).format("DD/MM/YYYY")
                        );
                      }
                      if (e.target.value == "") {
                        setFieldValue("pickup_date", "");
                      }

                      e.target.value.length >= 1 || values.det != ""
                        ? setComDisable(true)
                        : setComDisable(false);
                    }}
                    onBlur={handleBlur}
                    style={{ width: "50%", marginRight: 5 }}
                    InputLabelProps={{ shrink: true }}
                    disabled={DetDemDisable}
                    value={values.dem}
                  />
                  {errors.dem && touched.dem && errors.dem}
                  <TextField
                    name="com"
                    type="number"
                    label="COM"
                    variant="outlined"
                    placeholder="COM"
                    onChange={(e) => {
                      setFieldValue("com", e.target.value);
                      setCom_caluateSelect(true);
                      if (e.target.value == "") {
                        setCom_caluateSelect(false);
                        setFieldValue("pickup_date", "");
                      }
                      e.target.value.length >= 1
                        ? setDetDemDisable(true)
                        : setDetDemDisable(false);
                    }}
                    onBlur={handleBlur}
                    style={{ width: "50%", marginRight: 5 }}
                    InputLabelProps={{ shrink: true }}
                    value={values.com}
                    disabled={ComDisable}
                  />
                  {errors.com && touched.com && errors.com}
                  {com_caluateSelect ? (
                    <FormControl sx={{ width: "50%", mr: "5px" }}>
                      <InputLabel>คำนวณโดย</InputLabel>
                      <Select
                        name="choice_com_calculate"
                        value={values.choice_com_calculate}
                        label="คำนวณโดย"
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => {
                          setFieldValue("choice_com_calculate", e.target.value);

                          let date_now = +new Date(values.eta_pod);
                          if (
                            e.target.value == "1" &&
                            values.eta_pod != "" &&
                            values.com != ""
                          ) {
                            let com_value = -values.com + 1;
                            setFieldValue(
                              "pickup_date",
                              moment(
                                new Date(
                                  date_now + com_value * 24 * 60 * 60 * 1000
                                )
                              ).format("DD/MM/YYYY")
                            );
                          }
                          let date_closing = +new Date(values.closing_date);
                          if (
                            e.target.value == "2" &&
                            values.closing_date != "" &&
                            values.com != ""
                          ) {
                            let com_value = -values.com + 1;
                            setFieldValue(
                              "pickup_date",
                              moment(
                                new Date(
                                  date_closing + com_value * 24 * 60 * 60 * 1000
                                )
                              ).format("DD/MM/YYYY")
                            );
                          }
                        }}
                      >
                        <MenuItem value="" disabled>
                          <em>เลือก วันที่ใช้ในการคำนวณ </em>
                        </MenuItem>
                        <MenuItem value="1">
                          <em>ETA POD </em>
                        </MenuItem>
                        {/* <MenuItem value="2">
                          <em>CLOSING DATE </em>
                        </MenuItem> */}
                      </Select>
                    </FormControl>
                  ) : null}
                </Grid>
                <Grid item xs={6} sm={3} md={12} sx={{ display: "flex" }}>
                  <FormControl sx={{ width: "100%" }}>
                    <InputLabel>From</InputLabel>
                    <Select
                      name="from"
                      label="From"
                      style={{
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                      value={values.from}
                      InputLabelProps={{ shrink: true }}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <MenuItem value="" disabled>
                        <em>เลือก From </em>
                      </MenuItem>
                      {location_fetch_Data.map((option, index) => {
                        return (
                          <MenuItem key={index} value={option.LocationId}>
                            {option.LocationName}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <FormControl sx={{ width: "100%", marginLeft: "5px" }}>
                    <InputLabel>To</InputLabel>
                    <Select
                      name="to"
                      label="To"
                      style={{
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                      value={values.to}
                      InputLabelProps={{ shrink: true }}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <MenuItem value="" disabled>
                        <em>เลือก To </em>
                      </MenuItem>
                      {location_fetch_Data.map((option, index) => {
                        return (
                          <MenuItem key={index} value={option.LocationId}>
                            {option.LocationName}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Button
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                onClick={history.goBack}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                disabled={Submitting}
              >
                {Submitting && <CircularProgress size={22} />}
                {!Submitting && "SAVE"}
              </Button>
            </form>
          )}
        </Formik>
      </Card>
    </div>
  );
}
